import {Link} from "@/i18n/routing";
import {useTranslations} from 'next-intl';

export default function ProductBrands({ brands, onBrandSelect, brandInput }) {
  const t = useTranslations('catalog');
  return (
      <div className="widget">
        <h4 className="ltn__widget-title ltn__widget-title-border">
          {t('brands')}
        </h4>
        <div className="ltn__utilize-menu categories-menu">
          <ul>
            {brands.map(({title, alt}, idx) => (
                <li key={idx}>
                  <div className={`menu-title ${alt === brandInput ? 'selected' : ''}`}>
                    <Link
                        href={`/catalog?brand=${alt}&title=${title}`}
                        onClick={(e) => onBrandSelect(e, alt, title, alt === brandInput)}
                    >{title}</Link>
                  </div>
                </li>
            ))}
          </ul>
        </div>
      </div>
  );
};
